/**
 * UI Configuration Constants for ThinkMate
 * Centralizes animation timing, character limits, and other UI-related constants
 */

// Character input limits
export const CHARACTER_LIMITS = {
  CHECK_IN_RESPONSE: 150,
  ONBOARDING_RESPONSE: 150,
  DEFAULT: 150
} as const;

// Animation timing constants
export const ANIMATION_TIMING = {
  // Text animation: milliseconds per word
  MS_PER_WORD: 40,
  // Buffer time after text animation completes
  ANIMATION_BUFFER: 600,
  // Minimum animation duration
  MIN_DURATION: 500
} as const;

// Validation thresholds
export const VALIDATION = {
  VAGUE_RESPONSE_THRESHOLD: 3,
  VAGUE_RESPONSE_COUNT_THRESHOLD: 2 // For detecting predominantly vague responses
} as const;

// Common UI delays and timeouts
export const UI_DELAYS = {
  BUTTON_APPEAR_DELAY: 100,
  MESSAGE_FADE_IN: 200,
  TYPING_INDICATOR: 1000
} as const;

/**
 * Calculate text animation duration based on word count
 * @param text The text to animate
 * @returns Duration in milliseconds
 */
export const calculateTextAnimationDuration = (text: string): number => {
  const words = text.split(/\s+/).filter(word => word.length > 0);
  return Math.max(
    words.length * ANIMATION_TIMING.MS_PER_WORD + ANIMATION_TIMING.ANIMATION_BUFFER,
    ANIMATION_TIMING.MIN_DURATION
  );
};

/**
 * Calculate character limit for a given input type
 * @param type The type of input (defaults to DEFAULT)
 * @returns Character limit
 */
export const getCharacterLimit = (type: keyof typeof CHARACTER_LIMITS = 'DEFAULT'): number => {
  return CHARACTER_LIMITS[type];
};